export default __webpack_public_path__ + "static/media/learn-area-btn.ffe68508.png";